// Helper to process smart signal custom fields.
// Responsibilities:
// 1. Filter only fields with origin === "smart_signals".
// 2. Combine location.latitude & location.longitude into location.coordinates (removing originals).
// Returns a new array (does not mutate the passed customFields array).
// Defensive: skips steps gracefully if expected fields are missing.

import { formatText } from "@rageeb/frontend-lib";

export interface SmartSignalField {
	key: string;
	label: string;
	data_type: string;
	value: string | number | boolean;
	origin?: string;
	[key: string]: any; // allow extra metadata
}

export const transformSmartSignals = (
	customFields: SmartSignalField[] | undefined | null,
): SmartSignalField[] => {
	if (!Array.isArray(customFields) || customFields.length === 0) return [];

	// Shallow clone to avoid mutating caller state
	let smartSignals = customFields
		.filter((f) => f?.origin === "smart_signals")
		.map((f) => ({ ...f }));

	if (smartSignals.length === 0) return [];

	// Combine location latitude/longitude
	const locationLatitude = smartSignals.find((f) =>
		f.key?.includes("location.latitude"),
	);
	const locationLongitude = smartSignals.find((f) =>
		f.key?.includes("location.longitude"),
	);

	if (locationLatitude || locationLongitude) {
		const locationCoordinates: SmartSignalField = {
			data_type: "unknown",
			label: "",
			key: "location.coordinates",
			origin: "smart_signals",
			value: `${locationLatitude?.value}, ${locationLongitude?.value}`,
		};
		smartSignals = smartSignals.filter(
			(f) =>
				!f.key?.includes("location.latitude") &&
				!f.key?.includes("location.longitude"),
		);
		smartSignals.push(locationCoordinates);
	}
	smartSignals.map((f: SmartSignalField) => {
		f.label = formatText(f.key);
		return f;
	});

	return smartSignals;
};
